"use client";
import * as React from "react";

export interface sanityConfig {
  projectId: string;
  dataset: string;
}

export type ImageContextValue = {
  sanityConfig?: sanityConfig;
};

export type ImageContextType = {
  context: ImageContextValue;
  setContext: React.Dispatch<React.SetStateAction<ImageContextValue>>;
};

export const ImageContext = React.createContext<ImageContextType | null>(null);

export const useImageContext = (): ImageContextType => {
  const context = React.useContext(ImageContext);
  if (!context) {
    console.error(
      "ImageContext is undefined. Make sure you use ImageProvider before using this hook."
    );
    return;
  }
  return context;
};

type ImageContextProps = {
  initContextValue: ImageContextValue;
  children: React.ReactNode;
};

const ImageProvider = ({ initContextValue, children }: ImageContextProps) => {
  const [context, setContext] =
    React.useState<ImageContextValue>(initContextValue);

  const value: ImageContextType = {
    context,
    setContext,
  };

  return (
    <ImageContext.Provider value={value}>{children}</ImageContext.Provider>
  );
};

export default ImageProvider;
